import moment from 'moment';

const defaultFormat = 'YYYY-MM-DD';
const defaultTimeFormat = 'HH:mm:ss';

function startOfMonth(date) {
  return moment(date).clone().startOf('month').format(defaultFormat);
}

function endOfMonth(date) {
  return moment(date).clone().endOf('month').format(defaultFormat);
}

function getFirstLastDayMonth(date) {
  return {
    fromDate: startOfMonth(date),
    toDate: endOfMonth(date)
  };
}

function getCurrentMonthDetails(activeMonth) {
  if (!activeMonth) return '';
  return `${moment(activeMonth?.month + 1, 'M').format('MMMM')} ${activeMonth?.year}`;
}

function getISODate(date) {
  return moment(date).format(defaultFormat);
}

function getFormattedTime(time) {
  return moment.utc(time, 'HH:mm:ss.SSSZ').format(defaultTimeFormat);
}

function dateIsBefore(a, b) {
  return moment(a).isBefore(b, 'day');
}

function dateFormat(date, format = 'dddd D MMMM YYYY') {
  return moment(date).format(format);
}

function isIsoDateFormat(str) {
  return moment(str, 'YYYY-MM-DD', true).isValid();
}

function toDate(str) {
  return moment(str).toDate();
}

/**
 * Converts a date input to the provided format
 * @param {string|Date|Moment} date - The date input to format.
 * @param {string} format - The format we want the date.
 * @returns {string} The formatted date string
 */

function formatDateToCustomFormat(date, format) {
  try {
    // Handle different date input types
    if (typeof date === 'string') {
      // Parse string into a Date object
      date = new Date(date);
    } else if (moment && moment.isMoment(date)) {
      // Moment.js date, convert to native Date object
      date = date.toDate();
    } else {
      throw new Error('Invalid date argument type');
    }
    return moment(date).format(format);
  } catch (error) {
    console.log(error);
    return 'Invalid date';
  }
}

export {
  startOfMonth,
  endOfMonth,
  getFirstLastDayMonth,
  getCurrentMonthDetails,
  getISODate,
  getFormattedTime,
  dateIsBefore,
  dateFormat,
  isIsoDateFormat,
  toDate,
  formatDateToCustomFormat
};
